<template>
  <div
    v-if="loading"
    key="loadingData"
  >
    <AtomLoadingSecondary/>
  </div>
  <div v-else class="m-card-record-info">
    <div class="m-card-record-info-body display-flex-column">
      <div class="margin-bottom-small display-inline-block">
        <h4>
          ACADEMIA
        </h4>
        <p>
          <span class="info-icon-left info-icon-billing">
            <i class="fas fa-school"></i>
          </span>
          <span>
            {{academia.nombre_academia}}
          </span>
        </p>
        <p>
          <span class="info-icon-left info-icon-billing">
            <i class="fas fa-history"></i>
          </span>
          <span>
            La academia esta
            <span
              v-if="academia.licencia.activa"
              class="font-weight-bold info-text-highlighted-success"
            >
              Activa
            </span>
            <span
              v-else
              class="font-weight-bold info-text-highlighted-danger"
            >
              Inactiva
            </span>
              desde el {{ $moment.parseZone(academia.licencia.fecha_alta).format('D MMMM, YYYY') }}
          </span>
        </p>
        <p>
          <span class="info-icon-left info-icon-billing">
            <i class="fas fa-tag"></i>
          </span>
          <span>
            La categoría de la academia es <u>{{ academia.categoria_academia }}</u>
          </span>
        </p>
        <p style="align-items:baseline !important;">
          <span class="info-icon-left info-icon-billing">
            <i class="fas fa-tag"></i>
          </span>
          <span v-if="(academia.categorias_productos).length > 0">
            <span class="font-weight-bold">Las categorías de productos utilizadas son las siguientes</span>
            <ul style="list-style: none; margin: 0; padding: 0;">
              <li
                v-for="(categoria, index) in academia.categorias_productos"
                :key="index"
                style="font-style: italic; padding-bottom: 5px;"
                >
                - {{ categoria.nombre }}
              </li>
            </ul>
          </span>
          <span v-else>
            No hay productos con categorías
          </span>
        </p>
        <p>
          <span class="info-icon-left info-icon-billing">
            <i class="fas fa-link"></i>
          </span>
          <a
            :href="`${tienda}/${academia.url_academia}`"
            target="_blank"
            >
              {{ tienda + '/' +academia.url_academia }}
          </a>
        </p>
      </div>

      <div class="margin-bottom-small display-inline-block">
        <h4>
          CLIENTE
        </h4>
        <p>
          <span class="info-icon-left info-icon-billing">
            <i class="fas fa-user-alt"></i>
          </span>
          <span>
            {{academia.razon_social + ' ' + academia.email_propietario}}
          </span>
        </p>
        <p>
          <span class="info-icon-left info-icon-billing">
            <i class="fas fa-map-marker-alt"></i>
          </span>
          <span>
            {{academia.pais}}
          </span>
        </p>
      </div>

      <div>
        <h4>
          LICENCIA
        </h4>
        <p>
          <span class="info-text-left">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-users"></i>
            </span>
              Alumnos
            <span class="font-size-xsmall text-color-black-45"> ({{ academia.recursos_usados.alumnos }} de {{ academia.recursos_usados.maximo_alumnos }}) </span>
          </span>
          <span class="info-text-right">
            {{ this.getPorcentaje(academia.recursos_usados.alumnos, academia.recursos_usados.maximo_alumnos) }}%
          </span>
        </p>
        <p>
          <span class="info-text-left">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-folder"></i>
            </span>
              Proyectos
            <span class="font-size-xsmall text-color-black-45"> (ilimitado) </span>
          </span>
          <span class="info-text-right">
            <i class="far fa-infinity"></i>
          </span>
        </p>
        <p>
          <span class="info-text-left">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-map-marker-alt"></i>
            </span>
              Mapas de Aprendizaje
            <span class="font-size-xsmall text-color-black-45"> (ilimitado) </span>
          </span>
          <span class="info-text-right">
            <i class="far fa-infinity"></i>
          </span>
        </p>
        <p>
          <span class="info-text-left">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-box-open"></i>
            </span>
              Productos
            <span class="font-size-xsmall text-color-black-45"> (ilimitado) </span>
          </span>
          <span class="info-text-right">
            <i class="far fa-infinity"></i>
          </span>
        </p>
        <p v-if="false">
          <span class="info-text-left">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-envelope"></i>
            </span>
              Listas de e-mail
          </span>
          <span class="info-text-right">
            {{ academia.recursos_usados.maximo_emails }}
          </span>
        </p>
        <p>
          <span class="info-text-left">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-file-alt"></i>
            </span>
              Puntos de venta
            <span class="font-size-xsmall text-color-black-45"> (ilimitado) </span>
          </span>
          <span class="info-text-right">
            <i class="far fa-infinity"></i>
          </span>
        </p>
        <p>
          <span class="info-text-left">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-graduation-cap"></i>
            </span>
              Universidad Profesional
          </span>
          <span class="info-text-right">
            <span v-if="academia.licencia.tipo_universidad" class="font-weight-bold info-text-highlighted-success"> Si </span>
            <span v-else class="font-weight-bold info-text-highlighted-danger"> No </span>
          </span>
        </p>
        <p>
          <span class="info-text-left">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-puzzle-piece"></i>
            </span>
              Integraciones
          </span>
          <span class="info-text-right">
            <span class="info-icon-right info-icon-billing">
              <i :class="academia.licencia.integraciones ? 'far fa-check font-weight-bold' : 'far fa-cross font-weight-bold'"></i>
            </span>
          </span>
        </p>
        <p>
          <span class="info-icon-left info-icon-billing">
            <i class="fas fa-link"></i>
          </span>
          <a
            :href="`${academiaUrl}/${academia.licencia.venta}/registro`"
            target="_blank"
            >
              {{ academiaUrl + '/' + academia.licencia.venta + '/registro'}}
          </a>
        </p>
      </div>
    </div>

  </div>
</template>

<script>
import configApp from '@/config'

export default {
  name: 'MoleculeEditionBillingAcademiesData',

  data () {
    return {
      academia: [],
      academiaId: '',
      academiaUrl: '',
      loading: false,
      tienda: ''
    }
  },

  created () {
    this.academiaId = this.$route.params.subid
    this.tienda = configApp.marketPlaceDomain
    this.academiaUrl = configApp.appAcademyDomain + '/gestion/mis-ventas'
    this.readAcademiaDatos()
  },

  methods: {
    getPorcentaje (valor, maximo) {
      return parseInt((valor * 100) / maximo)
    },

    readAcademiaDatos () {
      this.loading = true
      this.$services.read('academia', 'readAcademiaDatos', {}, [this.academiaId])
        .then(response => {
          this.loading = false
          this.academia = response.data
          console.log(this.academia)
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
